import { userService } from '../services';
import { apiUrl } from '../config/constants';
import { authHeader } from '../helpers/auth-header';
import {GET_USER_INFO, GET_STORE_INFO, GET_CART_COUNT, GET_SURF_SIDE, GET_HEADER_SCRIPT, GET_MENU_AVAILABILITY} from '../config/actionTypes';

const HEADER_SCRIPT_TIMEOUT = 5000;

export const globals = {
    userInfo,
    storeInfo,
    cartCount,
    getSurfSide,
    getHeaderScript,
    getMenuAvailability
};

function userInfo() {
    return dispatch => {
        userService.GetInfo('/users/info', '')
            .then(
                user => {
                    dispatch(success(user));
                }
            );
    };
    function success(user) { return { type: GET_USER_INFO, user } }
}
function storeInfo() {
    return dispatch => {
        userService.GetInfo('/stores/info', '')
            .then(
                data => {
                    dispatch(success(data));
                }
            );
    };
    function success(storeInfo) { return { type: GET_STORE_INFO, storeInfo } }
}

function getSurfSide() {
    return dispatch => {
        userService.GetInfo('/surfside', '')
            .then(
                data => {
                    dispatch(success(data));
                }
            );
    };
    function success(surfSide) { return { type: GET_SURF_SIDE, surfSide } }
}
// Deliberately NOT routed through userService.GetInfo/handleResponse: that pipeline
// logs the user out on 401 and shows a toast on 403/500, which is unacceptable for a
// passive, non-critical marketing-script endpoint.
function getHeaderScript() {
    return async (dispatch, getState) => {
        if (getState()?.headerScript?.loaded) return;

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), HEADER_SCRIPT_TIMEOUT);

        try {
            const res = await fetch(`${apiUrl}/marketplace/header`, {
                method: 'GET',
                headers: authHeader(),
                signal: controller.signal
            });
            if (!res.ok) {
                dispatch(failure());
                return;
            }
            const data = await res.json();
            const script = typeof data?.header_script === 'string' ? data.header_script.trim() : '';
            dispatch(success(script));
        } catch (e) {
            // Transient failure (network, abort/timeout, malformed JSON): keep loaded=false so
            // the next visit to Home retries. Home dispatches once per mount, never on a timer.
            dispatch(failure());
        } finally {
            clearTimeout(timeoutId);
        }
    };
    function success(headerScript) { return { type: GET_HEADER_SCRIPT, headerScript, loaded: true } }
    function failure() { return { type: GET_HEADER_SCRIPT, headerScript: '', loaded: false } }
}
// Bypasses userService like getHeaderScript; on any error the menu keeps showing everything.
function getMenuAvailability() {
    return async dispatch => {
        try {
            const res = await fetch(`${apiUrl}/marketplace/menu-availability`, {
                method: 'GET',
                headers: authHeader()
            });
            if (!res.ok) return;
            const data = await res.json();
            dispatch({
                type: GET_MENU_AVAILABILITY,
                dispensaries: data?.dispensaries !== false,
                deliveryAreas: data?.delivery_areas !== false,
                loaded: true
            });
        } catch (e) {}
    };
}
function cartCount() {
    return dispatch => {
        userService.GetInfo('/shopping_cart/count', '')
            .then(
                data => {
                    localStorage.setItem('itemsCountInShoppingCart', JSON.stringify(data.count));
                    dispatch(success(data.count));
                }
            );
    };
    function success(count) { return { type: GET_CART_COUNT, count } }
}

